import { get, put, post, default as com } from '@/common/api'

let api = {
  /** ****************** 发票 ****************** **/
  queryRegInvoice: (para) => {
    return get('/api/op/regInvoice', para)
  },
  stockIn: (para)=>{
    return post('/api/op/regInvoice/stockIn',para)
  },
  collect:(para)=>{
    return post('/api/op/regInvoice/collect',para)
  },
  recovery: (para)=>{
    return post('/api/op/regInvoice/recovery',para)
  },
  frmLoss: (para)=>{
    return post('/api/op/regInvoice/frmLoss',para)
  },
  /** ****************** 员工 ****************** **/
  queryStaff: com.queryStaff
  
}
export default api
